import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Health } from '../interface/health.interfaces';

@Injectable()
export class HealthService {
    constructor(private http: HttpClient) {}

    currentHealthData: Health;

    //sort roster
    getHealth(): Observable<Health> {
        return this.http.get<Health>('/health', {});
    }

    setCurrent(inHealth: Health){
        this.currentHealthData = inHealth;
    }
}
